import useDataObjectTransform from "./useDataObjectTransform"
import { SolrQueryBuilder } from "../services/solr/SolrQueryBuilder"
import { SolrApi } from "../services/solrApi"
import solrConfig from "../config/solr.json"

const queryConfig = solrConfig.query
const clientConfig = solrConfig.server
const solrClient = new SolrApi(clientConfig)

/**
 * Hook to consume geo entity data and transform it into a UI component format.
 */
const useGeoPagesSolrData = () => {
  const { subPagesIndexToDynamicSubPageItems, countryBasedPagesDataTransform } =
    useDataObjectTransform()

  /**
   * Get sub pages for a given parentId.
   * @param {string} parentId The parent nid.
   * @returns {Promise<{links: {label: string, url: string}[]}>}
   */
  const getDynamicSubNav = async (parentId) => {
    const solrQuery = new SolrQueryBuilder(queryConfig)
    const queryQ = {
      index_id: "geo_entity_index",
      ss_type: "sub_page",
    }
    if (parentId) {
      queryQ.its_parent_nid = parentId
    }

    solrQuery.q(queryQ).sort({ timestamp: "asc" })

    const response = await solrClient.runQuery(solrQuery)
    const solrRecords = response?.response?.docs || null
    return subPagesIndexToDynamicSubPageItems(solrRecords)
  }

  const getTravelInformationPages = async (countryId) => {
    const solrQuery = new SolrQueryBuilder(queryConfig)
    solrQuery
      .q({
        index_id: "geo_entity_index",
        ss_type: "travel_information",
        its_country_nid: countryId ?? 0,
      })
      .sort({ timestamp: "asc" })

    const response = await solrClient.runQuery(solrQuery)
    const solrRecords = response?.response?.docs || null
    const transformedData = countryBasedPagesDataTransform(solrRecords)
    return transformedData
  }

  const getTripIdeaPages = async (countryId) => {
    const solrQuery = new SolrQueryBuilder(queryConfig)
    solrQuery
      .q({
        index_id: "geo_entity_index",
        ss_type: "trip_idea",
        its_country_nid: countryId ?? 0,
      })
      .sort({ timestamp: "asc" })
      .rows(100)

    const response = await solrClient.runQuery(solrQuery)
    const solrRecords = response?.response?.docs || null
    const transformedData = countryBasedPagesDataTransform(solrRecords)
    return transformedData
  }

  return {
    getDynamicSubNav,
    getTravelInformationPages,
    getTripIdeaPages,
  }
}

export default useGeoPagesSolrData
